<template>
  <div style="background-color: #ffffff">
    <div class="iframe-container">
      <iframe
        :src="termsUrl"
        style="
          position: fixed;
          width: 100%;
          height: 100%;
          border: none;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
        "
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsPage",
  computed: {
    termsUrl() {
      return "https://volyn-api.billing.city/terms.html";
    },
  },
};
</script>
